import * as _ from "lodash";
import * as $ from "jquery";
import {BaseDashboardWidgetView, BaseDashboardWidgetViewOptions} from "../_BaseWidgetView";
import {BaseSimpleWidget} from "../simplewidget/SimpleWidget";
import { PermissionCollection } from "../../../../collections/Permissions";
import { ModuleCollection } from "../../../../collections/Modules";
import { WIDGET_DIMENSIONS } from "../../../../common/widgetLayout";

declare var App: any;

export class LobbyViewWidget extends BaseSimpleWidget {

    PermissionCollection: PermissionCollection;
    ModuleCollection: ModuleCollection;

    protected lobbyViewTemplate = _.template(require('templates/dashboard/widgets/lobbyview/lobbyview.html'));
    private dName;
    private dUrl;

    constructor(options: BaseDashboardWidgetViewOptions) {
        super(<any>_.merge({
            tagName: "div",
            className: 'widget widget-w-1 lobby-view-widget',
            events: {}
        }, options));

        this.$el.attr('data-widget-id', this.options.widget.get('id'));

        this.dName = this.options.widget.getParamValue('DASHBOARD_NAME', null);
        this.dUrl = `${window["CONFIG"].lobbyView.url}${this.options.widget.get('public_id')}`;
    }

    renderChannels() {
        this.$('.w-rows').html(this.lobbyViewTemplate({
            dashboardName: this.dName ? this.dName : 'IAQ Dashboard',
            dashboardUrl: this.dUrl ? this.dUrl : 'https://my.senseware.co/',
            dashboardId: this.options.widget.get('dashboard_id'),
        }));
        
        // Set fixed height using the shared base height constant
        this.$('.body.w-channels').css('height', WIDGET_DIMENSIONS.BASE_HEIGHT + 'px');
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/dashboard/widgets/lobbyview/LobbyViewWidget.ts